
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  checkoutPartsPdfButton: {
    id: "checkoutPartsPdfButton.button",
    defaultMessage: "Download PDF",
  },
  submitAsRequest: {
    id: "submitAsRequest.label",
    defaultMessage: "Request offer"
  },
  submitAsOffer: {
    id: "submitAsOffer.label",
    defaultMessage: "SAP transfer offer"
  },
  submitAsOrder: {
    id: "submitAsOrder.label",
    defaultMessage: "SAP transfer order",
  },
  save: {
    id: "checkoutSave.label",
    defaultMessage: "Save",
  },
  orderIsFailed: {
    id: "checkoutSave.orderIsFailed",
    defaultMessage: "Order has failed to submit to the SAP system. Please duplicate the configuration and try again later.",
  },
  orderIsQueued: {
    id: "checkoutSave.orderIsQueued",
    defaultMessage: "Order has failed to submit to the SAP system. It has been queued for later submission.",
  },
  timePeriodNote: {
    id: "checkoutParts.timePeriodNote",
    defaultMessage: "Note:"
  },
  timePeriodNoteText: {
    id: "checkoutParts.timePeriodNoteText",
    defaultMessage: "Please select the period for the price validity"
  },
  timePeriodAccessoriesLabel: {
    id: "checkoutParts.timePeriodAccessoriesLabel",
    defaultMessage: "Time Period Accessories"
  },
  timePeriodWashbasinLabel: {
    id: "checkoutParts.timePeriodWashbasinLabel",
    defaultMessage: "Time Period Washbasin"
  },
  articleNumber: {
    id: "CutoutPartDetail.article",
    defaultMessage: "Article number"
  }
});


export default MESSAGES;
